import React from 'react';
import RootComponent from './RootComponent';
import '@kuaizhan/kedit-font';

function App({ ds }: { ds: any }){
    return <RootComponent ds={ds} />
}

export default App;
